import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const addEvent = async (title, token) => {
    let postdata = {
        title: title,
        slug: title.replace(" ", "-")
    }
  return await axios.post(`${API_BASE_URL}/event/add`, postdata, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const getEvents = async (data, token) => {
    return await axios.post(`${API_BASE_URL}/event/get`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
};

export const getEventImages = async (id, token) => {
    return await axios.get(`${API_BASE_URL}/event/get-images/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
};

export const uploadEventImages = async (formData, token, id) => {
    return await axios.post(`${API_BASE_URL}/event/upload-event-images/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
};

export const updateEventStatus= async (id, active, token) => {
  return await axios.put(`${API_BASE_URL}/event/update-status/${id}`, {active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const editEvent = async (id, data, token) => {
  return await axios.put(`${API_BASE_URL}/event/edit/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const updateStatusEventImage= async (id, row, token) => {
  return await axios.put(`${API_BASE_URL}/event/update-image-status/${id}`, {name: row.name, active: !row.active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};